var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"ma-2 pa-0 switch",attrs:{"value":_vm.item.active,"hide-details":"","inset":""},on:{"click":function($event){$event.stopPropagation();return _vm.toggleActive.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }